
import { schema } from "./types";
import { OverviewPanel,OperatorPanel, ParameterPanel } from '.';
import { IAutomationAppComponent } from "../../types";
import { BsPinMap } from "react-icons/bs";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: BsPinMap,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ParameterPanel: ParameterPanel,
    /*createConfig:     {
        name: "Location",
        description: "Location",
        panel: OverviewPanel,
        defaultState: { latitude: 47.09553579018164, longitude: 15.721675584881703  },
    },*/
}